import { ClientOrderTrackingOrderFolder } from "@redotech/redo-model/views/folders";
import { ClientOrderTrackingOrderView } from "@redotech/redo-model/views/views";
import * as z from "zod";
import { null as zNull } from "zod";

export const getOrderTrackingOrderViewsAndFolders = {
  name: "getOrderTrackingOrderViewsAndFolders" as const,
  input: zNull(),
  output: z.object({
    folders: z.array(ClientOrderTrackingOrderFolder),
    views: z.array(ClientOrderTrackingOrderView),
  }),
};
